import styled from "@emotion/styled"
import { PIcon } from "@porsche-design-system/components-react"
import { colorSurface, getFocusVisibleStyle, radiusMd } from "@porsche-design-system/components-react/emotion"

interface NewsImageAddTileProps {
	label: string
	onClick: () => void
}

/** a gray tile with a plus that opens the file dialog, in place of a button */
export const NewsImageAddTile = ({ label, onClick }: NewsImageAddTileProps) => (
	<Tile>
		<button aria-label={label} data-testid="news-image-add" type="button" onClick={onClick}>
			<PIcon name="plus" size="medium" />
		</button>
	</Tile>
)

const Tile = styled.div`
	aspect-ratio: 4 / 3;
	border-radius: ${radiusMd};
	background: ${colorSurface};

	> button {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		padding: 0;
		border: none;
		border-radius: ${radiusMd};
		background: transparent;
		color: inherit;
		cursor: pointer;
		${getFocusVisibleStyle()}
	}
`
